import { useEffect } from "react";

function PreAlert() {
  useEffect(() => {
    // Przekierowuje użytkownika na podany URL, gdy komponent się załaduje
    window.location.href = "https://slamwarehouse.com";
  }, []); // Pusta tablica zależności sprawia, że efekt uruchamia się tylko raz

  // Zwraca prosty komunikat na czas przekierowania
  return <p>Przekierowywanie...</p>;
}

export default PreAlert;